import { useQuery } from "@tanstack/react-query";
import { getGameFiles } from "api/services/game-lesson-service";
import { useAuthContext } from "hooks/useAuthContext";
import { FileFlat } from "models/FileFlat";

export const GAME_FILES_QUERY_KEY = ["game-files"] as const;

export const useGetGameFileList = () => {
    const { userState } = useAuthContext();
    const workspaceId = userState.user.selectedWorkspace.workspaceId;

    const query = useQuery({
        queryKey: [...GAME_FILES_QUERY_KEY, workspaceId],
        queryFn: async (): Promise<FileFlat[]> => {
            if (!workspaceId) return [];
            const response = await getGameFiles({ workspaceId });
            if (!response.success || !response.data) {
                throw new Error(response.message ?? "getGameFiles.error");
            }
            return response.data;
        },
        enabled: !!workspaceId,
    });

    return {
        files: query.data ?? [],
        gameFilesLoading: query.isLoading || query.isFetching,
        refetch: query.refetch,
    };
};
